export default "/staticreactui/static/media/static/media/preloader_blend.0a874b7d.gif";